import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center space-x-8" }, "lensfolio", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lenses, (lens, k) => {
      return (_openBlock(), _createElementBlock("div", { key: k }, [
        _createVNode(_component_router_link, {
          to: _ctx.localizedUrl(lens.path)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(lens.maker) + " / " + _toDisplayString(lens.name), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}